import '../plugins/custom-form.js';

export default function initCustomForms() {
  jcf.setOptions('Select', {
    wrapNative: false,
  });
  jcf.replaceAll();
}
